// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { wemix as _wemix } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the wemix chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1111
 * Chain Name: WEMIX
 * Default Block Explorer: https://explorer.wemix.com
 * Default RPC URL: https://api.wemix.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { wemix } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: wemix,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const wemix = createCommon({
	..._wemix,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
